import * as yup from 'yup';

const FORM_DATE_PATTERN = /^\d{2}-\d{2}-\d{4}$/;

const optionalFormDate = (label: string) =>
  yup
    .string()
    .notRequired()
    .matches(FORM_DATE_PATTERN, {
      message: `${label} must be in MM-DD-YYYY format.`,
      excludeEmptyString: true,
    });

/**
 * Permit calls formik's `validateField` for each of these on change. `validateField`
 * resolves the path with `yup.reach`, which throws "The schema does not contain the
 * path" when it is missing, so any schema used with <Permit> must spread these in.
 *
 * Kept beside Permit rather than in InstallPackage.utils so consumers do not pull in
 * that module's AddersTab import, which drags the PDF renderer with it.
 */
export const permitDateFields = {
  permitSubmittedDate: optionalFormDate('Permit Application Submitted'),
  permitApprovedDate: optionalFormDate('Permit Application Approval'),
  installScheduledDate: optionalFormDate('Install Date'),
};
